import type {
  PurchaseDraft,
  PurchaseDraftPayload,
  PurchaseLineInput,
  StationContextRef,
} from './purchases.dto.js';

export const purchaseDraftUpdateModeValues = ['replace', 'patch'] as const;
export type PurchaseDraftUpdateMode = (typeof purchaseDraftUpdateModeValues)[number];

export interface GetPurchaseDraftRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  laneId?: string | null;
}

export interface GetPurchaseDraftResponse {
  draft: PurchaseDraft | null;
}

export interface UpdatePurchaseDraftRequest {
  companyId: string;
  stationId: string;
  storeId: string;
  locationId: string;
  laneId?: string | null;
  mode?: PurchaseDraftUpdateMode;
  payload: PurchaseDraftPayload;
}

export interface UpdatePurchaseDraftResponse {
  draft: PurchaseDraft | null;
}

export interface AddPurchaseDraftLineRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  laneId?: string | null;
  line: PurchaseLineInput;
}

export interface AddPurchaseDraftLineResponse {
  draft: PurchaseDraft;
}

export interface ApplyPurchaseDraftLineAdjustmentRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  laneId?: string | null;
  draftId: string;
  lineId: string;
  presetId: string;
}

export interface ApplyPurchaseDraftLineAdjustmentResponse {
  draft: PurchaseDraft;
}

export interface ClearPurchaseDraftLineAdjustmentRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  laneId?: string | null;
  draftId: string;
  lineId: string;
}

export interface ClearPurchaseDraftLineAdjustmentResponse {
  draft: PurchaseDraft;
}

export interface DiscardPurchaseDraftRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  laneId?: string | null;
}

export interface DiscardPurchaseDraftResponse {
  discarded: boolean;
  station: StationContextRef;
}
